import { HTTP } from "@/utils/http-common"
import { dateToString, now, FMTS } from "@/utils/datetime"

export default {
  async getAll(companyId, queryArgs = null) {
    const path = `/documents/company/${companyId}/fieldtypes`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    results.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
    return results
  },

  async get(fieldtypeId) {
    const path = `/documents/fieldtypes/${fieldtypeId}`
    return (await HTTP.get(path)).data
  },

  async post(data) {
    let companyId = data.company.pk
    const path = `/documents/company/${companyId}/fieldtypes`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/documents/fieldtypes/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(fieldtypeId) {
    const path = `/documents/fieldtypes/${fieldtypeId}`
    return (await HTTP.delete(path)).data
  },

  async duplicate(fieldtypeId) {
    let responseGet = await this.get(fieldtypeId)
    let date = dateToString(now(), FMTS.FILE)
    responseGet.name = `${responseGet.name}-${date}`
    return await this.post(responseGet)
  }
}
